import { render, staticRenderFns } from "./SymposiumSessionDetail.vue?vue&type=template&id=302128ea&scoped=true"
import script from "./SymposiumSessionDetail.vue?vue&type=script&lang=js"
export * from "./SymposiumSessionDetail.vue?vue&type=script&lang=js"
import style0 from "./SymposiumSessionDetail.vue?vue&type=style&index=0&id=302128ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302128ea",
  null
  
)

export default component.exports